export default __webpack_public_path__ + "static/media/icon-card.b31746cd.png";